'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkles } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { useHelpWidget } from '../HelpWidgetContext';
const HelpMainMenu = () => {
  const $ = _c(16);
  const {
    setPanel,
    closeWidget
  } = useHelpWidget();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      label: "Shopping Assistant",
      panel: "ai_assistant",
      highlight: true,
      icon: faSparkles
    }, {
      label: "Sales Assistance",
      panel: "sales_assistance"
    }, {
      label: "Trade Program",
      panel: "trade_program"
    }, {
      label: "Swatch Samples",
      panel: "swatch_samples"
    }, {
      label: "Order Status",
      panel: "order_status"
    }, {
      label: "Contact",
      panel: "contact"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const menuButtons = t0;
  let t1;
  if ($[1] !== setPanel) {
    t1 = <div className="mb-4">{menuButtons.map(item => <button key={item.panel} onClick={() => setPanel(item.panel)} className={`btn btn-sm w-full mb-2 ${item.highlight ? "btn-primary" : "btn-default"}`}>{item.icon && <FontAwesomeIcon icon={item.icon} className="mr-1.5" />}{item.label}</button>)}</div>;
    $[1] = setPanel;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-primary font-medium">hive</div>;
    t3 = <div>820 nw glisan street</div>;
    t4 = <div>portland or 97209</div>;
    t5 = <span className="text-light">tele:</span>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div>{t5}{" "}<a href="tel:+1-503-242-1967" className="hover:text-primary transition-colors">503.242.1967</a></div>;
    t7 = <span className="text-light">toll free:</span>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div>{t7}{" "}<a href="tel:+1-866-663-4483" className="hover:text-primary transition-colors">1.866.663.4483</a></div>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="text-xs text-dark">{t2}{t3}{t4}{t6}{t8}<div className="mb-2"><a href="mailto:info@hivemodern.com" className="text-primary hover:underline">info@hivemodern.com</a></div></div>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== closeWidget) {
    t10 = <div className="text-xs flex gap-3"><Link href="/hive-modern-frequently-asked-questions" onClick={closeWidget} className="text-light hover:text-primary transition-colors">faq</Link><Link href="/hive-modern-store-policy" onClick={closeWidget} className="text-light hover:text-primary transition-colors">store policies</Link><Link href="/hive-modern-privacy-policy" onClick={closeWidget} className="text-light hover:text-primary transition-colors">privacy policy</Link><Link href="/hive-modern-cookies-policy" onClick={closeWidget} className="text-light hover:text-primary transition-colors">cookies</Link></div>;
    $[11] = closeWidget;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t1 || $[14] !== t10) {
    t11 = <div className="p-4 pt-3">{t1}{t9}{t10}</div>;
    $[13] = t1;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
};
export default HelpMainMenu;